// AdminRoute.js
// Guards all /admin/* pages. Calls /api/admin/verify to confirm the logged-in
// user's phone is in the ADMIN_PHONES list. Redirects to / if not admin.
// No changes to login flow — purely a frontend gate on top of existing auth.

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebaseConfig';

export default function AdminRoute({ children }) {
  const [status, setStatus] = useState('checking');
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    const verify = async () => {
      const user = auth.currentUser;
      if (!user) {
        navigate('/login');
        return;
      }
      try {
        const token = await user.getIdToken();
        const res   = await fetch('/api/admin/verify', {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!cancelled) {
          if (res.ok) setStatus('ok');
          else navigate('/');
        }
      } catch {
        if (!cancelled) navigate('/');
      }
    };

    verify();
    return () => { cancelled = true; };
  }, [navigate]);

  if (status === 'checking') {
    return <div style={{ padding: 40, fontFamily: 'sans-serif', color: '#555' }}>Verifying access…</div>;
  }
  return children;
}
